import { createContext } from "react";

export const StockContext = createContext();